module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="paylateBnr__title">\n    <h3>Покупайте сейчас — платите&nbsp;потом!</h3>\n</div>\n';
}
return __p;
};
